import type {
  GetJobHazardAnalysisListRequest,
  GetListResponseOfJobHazardAnalysisSimpleResponse,
  IStateMachineOfJobHazardAnalysisStateEnum,
  JobHazardAnalysisRequest,
  JobHazardAnalysisResponse,
  TransitionRequest,
} from 'src/api/ProactApiClient';
import {jobHazardAnalysisApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

export const jobHazardAnalysisApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getJobHazardAnalysisList: builder.query<
      GetListResponseOfJobHazardAnalysisSimpleResponse,
      GetJobHazardAnalysisListRequest
    >({
      queryFn: clientQuery(params =>
        jobHazardAnalysisApiClient.getList(params)
      ),
      providesTags: ['JobHazardAnalyses'],
    }),
    getJobHazardAnalysisStateMachine: builder.query<
      IStateMachineOfJobHazardAnalysisStateEnum,
      void
    >({
      queryFn: clientQuery(() => jobHazardAnalysisApiClient.getStateMachine()),
      providesTags: ['JobHazardAnalyses'],
    }),
    getJobHazardAnalysis: builder.query<JobHazardAnalysisResponse, number>({
      queryFn: clientQuery(id => jobHazardAnalysisApiClient.get(id)),
      providesTags: ['JobHazardAnalyses'],
    }),
    createJobHazardAnalysis: builder.mutation<
      JobHazardAnalysisResponse,
      JobHazardAnalysisRequest
    >({
      queryFn: clientQuery(request =>
        jobHazardAnalysisApiClient.create(request)
      ),
      invalidatesTags: ['JobHazardAnalyses'],
    }),
    updateJobHazardAnalysis: builder.mutation<
      JobHazardAnalysisResponse,
      JobHazardAnalysisRequest
    >({
      queryFn: clientQuery(request =>
        jobHazardAnalysisApiClient.update(request)
      ),
      invalidatesTags: ['JobHazardAnalyses'],
    }),
    deleteJobHazardAnalysis: builder.mutation<void, number>({
      queryFn: voidClientQuery(id => jobHazardAnalysisApiClient.delete(id)),
      invalidatesTags: ['JobHazardAnalyses'],
    }),
    transitionJobHazardAnalysis: builder.mutation<
      JobHazardAnalysisResponse,
      {id: number; request: TransitionRequest}
    >({
      queryFn: clientQuery(({id, request}) =>
        jobHazardAnalysisApiClient.transition(id, request)
      ),
      invalidatesTags: ['JobHazardAnalyses'],
    }),
  }),
});

export const {
  useGetJobHazardAnalysisListQuery,
  useGetJobHazardAnalysisStateMachineQuery,
  useGetJobHazardAnalysisQuery,
  useCreateJobHazardAnalysisMutation,
  useUpdateJobHazardAnalysisMutation,
  useDeleteJobHazardAnalysisMutation,
  useTransitionJobHazardAnalysisMutation,
} = jobHazardAnalysisApi;
